/**
 * [polecenie właściciela 2026-09-29] „zabroń składania wniosków starszych niż 5 dni wstecz, wyszarzaj te pola”.
 *
 * Lustro reguły serwera `DogSoft.Application.Helpers.HrGranicaWniosku`: typ wniosku niesie `granicaWsteczDni` (liczy SERWER — kategorie
 * czasu pracy/nieobecności i typy z pulą dni), a tu tylko zamieniamy ją na `min` kalendarza dla pól OKRESU. Serwer i tak odrzuca
 * starszą datę przy składaniu — kalendarz wyszarza ją, żeby człowiek w ogóle nie mógł jej wybrać.
 */
export const POLA_OKRESU = ["date", "dateFrom", "dateTo", "startDate", "endDate"];

const dzisWPolsce = (teraz = new Date()) => {
    const czesci = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Warsaw", year: "numeric", month: "2-digit", day: "2-digit" }).format(teraz);
    return new Date(`${czesci}T00:00:00`);
};

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Najwcześniejszy dzień okresu dla typu wniosku (`rrrr-mm-dd`) albo `undefined`, gdy typ nie ma granicy. */
export const najwczesniejszaDataOkresu = (typ, teraz = new Date()) => {
    const dni = typ?.granicaWsteczDni;
    if (dni == null) return undefined;
    const d = dzisWPolsce(teraz);
    d.setDate(d.getDate() - Number(dni));
    return iso(d);
};

/** `min` pola daty: granica wniosku (tylko pola okresu) i OD pary (dla pola DO) — późniejsza z nich. */
export const minPolaDaty = (nazwaPola, typ, minZPary, teraz = new Date()) => {
    const granica = POLA_OKRESU.includes(nazwaPola) ? najwczesniejszaDataOkresu(typ, teraz) : undefined;
    if (!granica) return minZPary || undefined;
    if (!minZPary) return granica;
    return minZPary > granica ? minZPary : granica;
};
